import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
// NOTE: React.StrictMode disabled because of incompatibility with leaflet's
// imperative DOM initialization (double-mount in dev throws "Map container is
// already initialized"). Production builds never double-mount so this only
// changes dev behavior. Re-enable once we migrate to a fully concurrent-safe
// map lib.
root.render(<App />);

// Register service worker so the app becomes PWA-installable on Android /
// desktop Chrome (Chromium requires an active SW + manifest to fire the
// `beforeinstallprompt` event). iOS Safari installs via Share → Add to Home
// Screen and doesn't need an SW, but having one doesn't hurt.
if ("serviceWorker" in navigator && window.isSecureContext) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .catch((err) => {
        // Non-fatal: PWA install just won't surface on Android, but the web
        // app continues to work normally.
        console.warn("Service worker registration failed:", err);
      });
  });
}

